<template>
  <div class="product-sales-records">
    <GlobalInfoBar
      title="产品售卖记录"
      subtitle="记录小程序端售出的每一笔产品，覆盖「直接购买折扣险种」与「升级付费折扣险种」两类订单，统一以产品编码追溯"
    />

    <div class="record-note">
      <strong>记录说明：</strong><br />·
      用户在小程序直接购买险种或升级付费并支付成功后，系统自动生成本页一条记录，无需人工录入。<br />·
      每笔记录均关联产品编码；当用户名称改了、原产品编码未变，追溯仍具体产品。<br />·
      「折数变化」只有升级付费的单才有值，直接购买显示「—」。
    </div>

    <GlobalChunk title="售卖记录" :padding="[20, 20, 20, 20]">
      <div class="filter-form">
        <div class="filter-item">
          <label>购买渠道</label
          ><el-select
            v-model="filters.channel"
            size="small"
            placeholder="全部渠道"
            clearable
            ><el-option label="全部渠道" value=""/><el-option
              label="小程序直接购买"
              value="1"/><el-option label="升级付费" value="2"
          /></el-select>
        </div>
        <div class="filter-item">
          <label>产品编码</label
          ><el-input
            v-model.trim="filters.productCode"
            size="small"
            placeholder="如 PRD0001"
            clearable
          />
        </div>
        <div class="filter-item">
          <label>设备串号</label
          ><el-input
            v-model.trim="filters.imei"
            size="small"
            placeholder="输入 IMEI"
            clearable
          />
        </div>
        <div class="filter-item">
          <label>销售门店</label
          ><el-select
            v-model="filters.shopName"
            size="small"
            placeholder="全部门店"
            clearable
            filterable
            >
            <!-- <el-option label="全部门店" value=""/> -->
            <el-option
              v-for="item in storeOptions"
              :key="item"
              :label="item"
              :value="item"
          /></el-select>
        </div>
        <div class="filter-item date-item">
          <label>购买时间(起)</label
          ><el-date-picker
            v-model="filters.startDate"
            size="small"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="年 / 月 / 日"
          />
        </div>
        <div class="filter-item date-item">
          <label>购买时间(止)</label
          ><el-date-picker
            v-model="filters.endDate"
            size="small"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="年 / 月 / 日"
          />
        </div>
        <div class="filter-actions">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="search"
            >搜索</el-button
          ><el-button size="small" icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
        </div>
      </div>
      <div class="toolbar">
        <el-button
          type="success"
          size="small"
          icon="el-icon-download"
          :loading="exporting"
          :disabled="exporting"
          @click="exportRecords"
          >导出记录</el-button
        >
      </div>

      <el-table v-loading="listLoading" :data="records" size="small" style="width:100%">
        <el-table-column prop="purchaseTime" label="购买时间" min-width="150" />
        <el-table-column prop="orderNo" label="订单号" min-width="165" />
        <el-table-column label="产品编码" min-width="110"
          ><template slot-scope="{ row }"
            ><span class="product-code">{{ row.productCode }}</span></template
          ></el-table-column
        >
        <el-table-column prop="productName" label="产品名称" min-width="95" />
        <el-table-column label="购买渠道" min-width="135"
          ><template slot-scope="{ row }"
            ><el-tag
              size="small"
              :class="
                String(row.channel) === '1' ? 'channel-direct' : 'channel-upgrade'
              "
              >{{
                row.channelText || (String(row.channel) === "1" ? "小程序直接购买" : "升级付费")
              }}</el-tag
            ></template
          ></el-table-column
        >
        <el-table-column prop="imei" label="设备串号" min-width="150" />
        <el-table-column prop="model" label="机型" min-width="155" />
        <el-table-column prop="phone" label="用户手机号" min-width="110" />
        <el-table-column prop="store" label="销售门店" min-width="160" />
        <el-table-column prop="payment" label="支付方式" min-width="90" />
        <el-table-column label="实付金额" min-width="90"
          ><template slot-scope="{ row }"
            ><span class="paid-amount"
              >¥{{ formatAmount(row.amount) }}</span
            ></template
          ></el-table-column
        >
        <el-table-column label="支付状态" min-width="85"
          ><template slot-scope="{ row }"
            ><el-tag :type="isPaid(row) ? 'success' : 'warning'" size="small">{{ row.payStatusText || '--' }}</el-tag></template
          ></el-table-column
        >
        <el-table-column
          prop="discountChange"
          label="折数变化"
          min-width="100"
        />
      </el-table>
      <div class="pagination-bar">
        <span>共 {{ total }} 笔</span
        ><el-pagination
          background
          small
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          @current-change="handlePageChange"
        />
      </div>
    </GlobalChunk>
  </div>
</template>

<script>
import _api, { shopNameList } from "@/utils/request";

export default {
  name: "ProductSalesRecords",
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      filters: {
        channel: "",
        productCode: "",
        imei: "",
        shopName: "",
        startDate: "",
        endDate: "",
      },
      records: [],
      storeOptions: [],
      total: 0,
      listLoading: false,
      exporting: false,
    };
  },
  created() {
    this.fetchRecords();
    this.fetchShopNames();
  },
  methods: {
    buildSearchParams() {
      const params = { page: this.currentPage, limit: this.pageSize };
      if (this.filters.channel) params.channel = this.filters.channel;
      if (this.filters.productCode) params.scheme_code = this.filters.productCode;
      if (this.filters.imei) params.imei = this.filters.imei;
      if (this.filters.shopName) params.shop_name = this.filters.shopName;
      if (this.filters.startDate) params.start_time = this.filters.startDate;
      if (this.filters.endDate) params.end_time = this.filters.endDate;
      return params;
    },
    fetchRecords() {
      this.listLoading = true;
      _api
        .saleRecordList(this.buildSearchParams())
        .then((res) => {
          const data = (res && res.data) || [];
          this.records = (Array.isArray(data) ? data : []).map(this.normalizeRecord);
          this.total = Number((res && res.count) || 0);
        })
        .catch(() => {
          this.$message.error("产品售卖记录获取失败，请稍后重试");
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    fetchShopNames() {
      shopNameList({})
        .then((res) => {
          const data = (res && res.data) || [];
          this.storeOptions = (Array.isArray(data) ? data : [])
            .map((item) => {
              if (typeof item === "string") return item;
              return item.shop_name || item.name || "";
            })
            .filter(Boolean);
        })
        .catch(() => {
          this.storeOptions = [];
        });
    },
    normalizeRecord(item) {
      return {
        purchaseTime: item.create_time || "--",
        orderNo: item.order_sn || "--",
        productCode: item.scheme_code || "--",
        productName: item.plan_name || "--",
        channel: item.channel,
        channelText: item.channel_text || "",
        imei: item.imei || "--",
        model: item.model || "--",
        phone: item.phone || "--",
        store: item.shop_name || "--",
        payment: item.pay_method === "wechat" ? "微信支付" : (item.pay_method || "--"),
        amount: Number(item.pay_amount || 0),
        payStatus: item.pay_status,
        payStatusText: item.pay_status_text || "--",
        discountChange: item.discount_change || "—",
      };
    },
    formatAmount(value) {
      return Number(value || 0).toFixed(2);
    },
    isPaid(row) {
      return String(row.payStatus) === "1" || row.payStatusText === "已支付";
    },
    search() {
      this.currentPage = 1;
      this.fetchRecords();
    },
    resetSearch() {
      this.filters = {
        channel: "",
        productCode: "",
        imei: "",
        shopName: "",
        startDate: "",
        endDate: "",
      };
      this.currentPage = 1;
      this.fetchRecords();
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchRecords();
    },
    exportRecords() {
      if (this.exporting) return;
      this.exporting = true;
      _api
        .saleRecordExport(this.buildSearchParams())
        .then((res) => {
          const blob = new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "产品售卖记录.xlsx";
          link.click();
          URL.revokeObjectURL(link.href);
          this.$message.success("导出成功");
        })
        .catch(() => {
          this.$message.error("导出失败，请稍后重试");
        })
        .finally(() => {
          this.exporting = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.product-sales-records {
  .record-note {
    margin: 12px 0 16px;
    padding: 12px 16px;
    color: #9a6700;
    font-size: 13px;
    line-height: 1.8;
    background: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 8px;
  }
  .filter-form {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: flex-end;
    padding-bottom: 14px;
  }
  .filter-item {
    width: 180px;
    label {
      display: block;
      margin-bottom: 5px;
      color: #606266;
      font-size: 13px;
    }
    .el-select,
    .el-input,
    .el-date-editor {
      width: 100%;
    }
  }
  .date-item {
    width: 150px;
  }
  .filter-actions {
    display: flex;
    gap: 10px;
  }
  .toolbar {
    padding: 0 0 12px;
  }
  .product-code {
    display: inline-block;
    padding: 2px 8px;
    color: #555;
    font-family: Consolas, monospace;
    font-size: 12px;
    line-height: 16px;
    background: #f5f5f5;
    border-radius: 3px;
  }
  .paid-amount {
    color: #ff4d4f;
    font-weight: 600;
  }
  /deep/ .channel-direct {
    color: #009b72;
    background: #edf9f5;
    border-color: #d7f2e7;
  }
  /deep/ .channel-upgrade {
    color: #7c3aed;
    background: #f5f0ff;
    border-color: #e9ddff;
  }
  /deep/ .el-table th {
    color: #555;
    background: #fafafa;
  }
  .pagination-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 16px;
    color: #606266;
    font-size: 13px;
  }
}
</style>
